import * as React from 'react'
import { withTranslations } from 'helpers'
import ImageSelector from './ImageSelector'
import ImageSlider from './ImageSlider'

const ProductImageViewer: React.FC<Props> = (props) => {
  return (
    <>
      <ImageSelector {...props} /> <ImageSlider {...props} />
    </>
  )
}

interface Props {
  primaryImageUrl: string
  productTitle: string
  imageUrls: Array<string>
}

export default withTranslations(ProductImageViewer)
